
import { constants } from './constants';
import PptxGenJS from 'pptxgenjs';

export function addTableToSlide(
     pptx: PptxGenJS,
  slide: PptxGenJS.Slide,
  tableObject: { rows: any[] },
  position: { x: number; y: number },
  slideDimensions: { width: number; height: number }
): void {
  
 
  const rowHeight = 0.5
  const usableHeight = slideDimensions.height
  const maxRowsPerSlide = Math.floor((usableHeight / rowHeight) - 4);

  let startIndex = 0;
  let currentSlide = slide;
 
  while (startIndex < tableObject.rows.length) {
    const rowsLeft = tableObject.rows.length - startIndex;
    const rowsToAdd = Math.min(maxRowsPerSlide, rowsLeft);
    const tableSlice = tableObject.rows.slice(startIndex, startIndex + rowsToAdd);
const tableDataWithHeight: PptxGenJS.TableRow[] = tableSlice.map(row =>
  row.map((cell: any) => ({
    text: cell === null || cell === undefined ? " " : cell,
    options: { h: rowHeight },
    overflow: "truncate" as any
  }))
);

currentSlide.addTable(tableDataWithHeight, createTableOptions(position, slideDimensions));

startIndex += rowsToAdd;
 
   
    if (startIndex < tableObject.rows.length) {
      currentSlide = pptx.addSlide();
    }
  }
}
 
const createTableOptions = (
  position: { x: number; y: number },
  slideDimensions: { width: number; height: number }
): PptxGenJS.TableProps => {
  return {
    x: position.x,
    y: position.y,
    w: slideDimensions.width - constants.SLIDE_MARGIN,
    fontSize: constants.DEFAULT_FONT_SIZE,
    border: {
      pt: constants.DEFAULT_BORDER_PT,
      color: constants.DEFAULT_BORDER_COLOR,
    },
     rowH: 0.4,      
    valign: "middle", 
  };
};